import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { AppConfig } from './app.config';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { CommonModule, CurrencyPipe, PercentPipe, DatePipe} from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';

import { OverlayContainer } from '@angular/cdk/overlay';
import { CustomOverlayContainer } from './theme/utils/custom-overlay-container';

import { AppRouting } from './app.routing';
import { SharedModule } from './shared/shared.module';

import { AppComponent } from './app.component';
import { AppSettings } from './app.settings';

import { PagesComponent } from './pages/pages.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';

import { UserManagementApiService } from './services/UserManagementApiService';
import { MoovManagementApiService } from './services/MoovManagementApiService';
import { AuthenticationService } from './services/AuthenticationService';
import { AccountService } from './services/AccountService';
import { FileDefinitionApiService } from "./services/FileDefinitionApiService";
import { MoovService } from "./services/MoovService";
import { BillingApiService } from "./services/BillingApiService";
import { ErrorComponent } from './pages/error/error.component';
import { CustomerErrorComponent } from './pages/error/customer-error.component';
import { AppInterceptor } from './theme/utils/app-interceptor';
import { ServiceWorkerModule } from '@angular/service-worker';
import { UpdateService } from './services/UpdateService';
import { BedrockApiService } from './services/BedrockApiService';

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}

@NgModule({
  declarations: [
    AppComponent,
    PagesComponent,
    NotFoundComponent,
    ErrorComponent,
    CustomerErrorComponent
  ],
  imports: [
    BrowserModule, 
    CommonModule,
    FormsModule,
    SharedModule,
    AppRouting,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: true, // !isDevMode(),
      registrationStrategy: 'registerImmediately'
    })
  ],
  providers: [AppConfig, 
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    provideAppInitializer(() => {
      const initializerFn = (initializeApp)(inject(AppConfig));
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const updateService = inject(UpdateService);
      updateService.checkForUpdates();
    }),
    { provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true },
    AppSettings, UserManagementApiService, MoovManagementApiService, AuthenticationService, AccountService, FileDefinitionApiService, MoovService, BillingApiService, BedrockApiService,
    { provide: OverlayContainer, useClass: CustomOverlayContainer },
    CurrencyPipe, PercentPipe, DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
